module.exports = __webpack_public_path__ + "static/media/1.db46a71f.jpeg";